import { render, staticRenderFns } from "./userDetailsSidebar.vue?vue&type=template&id=0d78fae7&scoped=true"
import script from "./userDetailsSidebar.vue?vue&type=script&lang=js"
export * from "./userDetailsSidebar.vue?vue&type=script&lang=js"
import style0 from "./userDetailsSidebar.vue?vue&type=style&index=0&id=0d78fae7&lang=scss&scoped=true"
import style1 from "./userDetailsSidebar.vue?vue&type=style&index=1&id=0d78fae7&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d78fae7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/ffa2b6072150c7f8/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d78fae7')) {
      api.createRecord('0d78fae7', component.options)
    } else {
      api.reload('0d78fae7', component.options)
    }
    module.hot.accept("./userDetailsSidebar.vue?vue&type=template&id=0d78fae7&scoped=true", function () {
      api.rerender('0d78fae7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/historical/user-details-view/userDetailsSidebar.vue"
export default component.exports